import {  makeStyles } from '@mui/styles';

export const useEnhancedTableHead = makeStyles((theme) => ({
   headTable:{
        maxHeight: "10px",
        backgroundColor: "#e9ecef"
   }
}));